import { useState } from "react";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faBoxOpen,
  faClipboardList,
  faTags,
  faLayerGroup,
  faTruck,
  faTicket,
  faIndianRupeeSign,
} from "@fortawesome/free-solid-svg-icons";
import AppContent from "../views/components/AppContent";
import AppSideDrawer, { SwayyMenu } from "../views/components/AppSideDrawer";
import Navbar from "../views/components/AppBar";
import SwayyThemeProvider from "../theme/SwayyThemeProvider";
import routes from "../routes";

const SwayyLayout = () => {
  const [open, setOpen] = useState(true);

  const menus: SwayyMenu[] = [
    {
      title: "Dashboard",
      path: "",
      icon: <FontAwesomeIcon icon={faChartLine} fontSize={14} />,
    },
    {
      title: "Products",
      path: "/products",
      icon: <FontAwesomeIcon icon={faBoxOpen} fontSize={14} />,
    },
    {
      title: "Options",
      path: "/catalog-options",
      icon: <FontAwesomeIcon icon={faTags} fontSize={14} />,
    },
    {
      title: "Categories",
      path: "/categories",
      icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={14} />,
    },
    {
      title: "Price lists",
      path: "/price-lists",
      icon: <FontAwesomeIcon icon={faIndianRupeeSign} fontSize={14} />,
    },
    {
      title: "Orders",
      path: "/orders/listing",
      icon: <FontAwesomeIcon icon={faClipboardList} fontSize={14} />,
    },
    {
      title: "Shipments",
      path: "/shipments",
      icon: <FontAwesomeIcon icon={faTruck} fontSize={14} />,
    },
    {
      title: "Coupons",
      path: "/coupons",
      icon: <FontAwesomeIcon icon={faTicket} fontSize={14} />,
    },
    // {
    //   title: "Invoices",
    //   path: "/invoices",
    //   icon: <FontAwesomeIcon icon={faFileInvoice} fontSize={14} />,
    // },
  ];

  const handleDrawerOpen = () => {
    setOpen((isOpen) => !isOpen);
  };

  return (
    <SwayyThemeProvider>
      <Navbar handleMenuClick={handleDrawerOpen} />
      <div className="wrapper">
        <AppSideDrawer
          open={open}
          handleDrawerClose={handleDrawerOpen}
          menus={menus}
        />
        <div
          className={`body swayy-body ${open ? "sidebar-open" : "sidebar-closed"}`}
          style={{ marginTop: "56px" }}
        >
          <AppContent routes={routes} />
        </div>
      </div>
    </SwayyThemeProvider>
  );
};

export default observer(SwayyLayout);
